module.exports = __webpack_public_path__ + "static/media/user_dummy_image.5de1e8e1.png";